import { render, staticRenderFns } from "./SyntheticMediaHistorical.vue?vue&type=template&id=b475009a&scoped=true"
import script from "./SyntheticMediaHistorical.vue?vue&type=script&lang=js"
export * from "./SyntheticMediaHistorical.vue?vue&type=script&lang=js"
import style0 from "./SyntheticMediaHistorical.vue?vue&type=style&index=0&id=b475009a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b475009a",
  null
  
)

export default component.exports